import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { SavedFilterView, SavedFilterViewsService } from "../../../service/services/misc/saved-filter-views/saved-filter-views.service";
import { DialogService } from "../../../service/services/misc/dialog/dialog.service";
import { ManageFilterViewsDialogComponent } from "../../dialogs/manage-filter-views-dialog/manage-filter-views-dialog.component";

@Component({
    selector: 'app-saved-filter-views',
    templateUrl: './saved-filter-views.component.html',
    styleUrls: ['./saved-filter-views.component.scss'],
    standalone: false
})
export class SavedFilterViewsComponent implements OnInit, OnChanges {
    @Input() disabled = false;
    @Input() currentViewName: string = 'Standard';
    @Input() organizationPath?: string;
    @Output() viewSelected = new EventEmitter<SavedFilterView>();
    @Output() manageViews = new EventEmitter<void>();

    savedViews: SavedFilterView[] = [];
    isOpen = false;

    constructor(
        private savedFilterViewsService: SavedFilterViewsService,
        private dialogService: DialogService
    ) {}

    ngOnInit(): void {
        this.loadSavedViews();
        this.checkForDefaultView();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['organizationPath'] && !changes['organizationPath'].firstChange) {
            this.checkForDefaultView();
        }
    }

    loadSavedViews(): void {
        this.savedViews = this.savedFilterViewsService.getAllViews();
        // Add "Standard" as the first option if it doesn't exist
        const hasStandard = this.savedViews.some(v => v.name === 'Standard');
        if (!hasStandard) {
            // Standard is a virtual view representing no filters
            this.savedViews.unshift({
                name: 'Standard',
                filters: { recursiveSearch: true },
                createdAt: new Date().toISOString()
            });
        }
    }

    checkForDefaultView(): void {
        if (this.organizationPath) {
            const defaultView = this.savedFilterViewsService.getDefaultView(this.organizationPath);
            if (defaultView) {
                this.currentViewName = defaultView.name;
                // Emit the default view to load its filters
                this.viewSelected.emit(defaultView);
            }
        }
    }

    onViewSelected(view: SavedFilterView): void {
        this.currentViewName = view.name;
        this.viewSelected.emit(view);
        this.isOpen = false;
    }

    onManageClick(): void {
        this.isOpen = false;

        const dialogRef = this.dialogService.open(ManageFilterViewsDialogComponent, {
            width: '800px',
            data: {
                organizationPath: this.organizationPath
            }
        });

        dialogRef.afterClosed.subscribe({
            next: (defaultViewName: string | null) => {
                if (defaultViewName !== null && defaultViewName !== undefined) {
                    // Reload views after managing
                    this.loadSavedViews();

                    // If the default view changed, update the current view
                    if (defaultViewName !== 'Standard' && defaultViewName !== this.currentViewName) {
                        const selectedView = this.savedViews.find(v => v.name === defaultViewName);
                        if (selectedView) {
                            this.onViewSelected(selectedView);
                        }
                    }
                }
            }
        });
    }

    toggleMenu(): void {
        if (!this.disabled) {
            this.loadSavedViews(); // Refresh list when opening
            this.isOpen = !this.isOpen;
        }
    }

    get hasViews(): boolean {
        return this.savedViews.length > 0;
    }
}
